import moment from 'moment';
import { getMomentDateString } from '@/utils/dateUtil';
import dateStore from '@/utils/dateStore';
import { CISO_INTERNAL_API } from '@/api';

const state = {
  tableData: [],
};

const actions = {
  async fetchImportLog({ commit }, args) {
    const params = {
      startDate: getMomentDateString(args.tradeDateRangeSelected[0]),
      endDate: getMomentDateString(args.tradeDateRangeSelected[1]),
      importStatus: args.statusTypeSelected,
    };
    try {
      const { data } = await CISO_INTERNAL_API.post('/reference/interfaceImportLog', params);
      data.forEach((obj) => {
        obj.importStartTime = moment(obj.importStartTime).utc().format('YYYY-MM-DD HH:mm:ss A');
      });
      commit('setTableData', data);
    } catch {
      this.$notify('Failed to Load Import Log', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};